<mat-toolbar color="accent">Invoice Amendment History</mat-toolbar>

<mat-dialog-content>
  <pr-invoice-amendment-history
    fxFlex
    [amendmentHistory]="amendmentHistory$ | ngrxPush"
    [selectedInvoice]="selectedInvoice$ | ngrxPush"
   />
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Close</button>
  </pt-buttons-container>
</mat-dialog-actions>
